// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"3a7fd305","239":"c83a3896","389":"83fc5fd3","417":"419a0d3b","450":"6b22714e","732":"a13ce2e6","857":"d015e37d"}[chunkId] + ".chunk.js";
};